import { render, staticRenderFns } from "./FlowDuration.vue?vue&type=template&id=45d74abb&"
import script from "./FlowDuration.vue?vue&type=script&lang=ts&"
export * from "./FlowDuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports